import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setTeamList } from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const teamList = yield call(connection.fetch.bind(connection), constants.RTM_IAM_TEAM_LIST);
  if (teamList.type === constants.RTM_IAM_TEAM_LIST_OK) {
    const teams = teamList.response.teams;
    yield put(setTeamList(teams));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceTeamList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_TEAM_LIST, catchErrors, sendRequest, connection);
}
